import * as tslib_1 from "tslib";
import { RailPackageServiceActionTypes } from './types';
var initialState = {
    groups: {},
    offers: {},
    products: {},
    variants: {},
    fetchingGroups: {
        default: false
    },
    fetchingOffers: {
        default: false
    },
    fetchingProducts: {
        default: false
    },
    fetchingVariants: {
        default: false
    },
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    switch (action.type) {
        case RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_GROUPS_RESPONSE: {
            return tslib_1.__assign({}, state, { groups: tslib_1.__assign({}, state.groups, (_a = {}, _a[action.storageKey] = action.groups, _a)), fetchingGroups: tslib_1.__assign({}, state.fetchingGroups, (_b = {}, _b[action.storageKey] = false, _b)) });
        }
        case RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_OFFERS_RESPONSE: {
            return tslib_1.__assign({}, state, { offers: tslib_1.__assign({}, state.offers, (_c = {}, _c[action.storageKey] = action.offers, _c)), fetchingOffers: tslib_1.__assign({}, state.fetchingOffers, (_d = {}, _d[action.storageKey] = false, _d)) });
        }
        case RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_PRODUCTS_RESPONSE: {
            return tslib_1.__assign({}, state, { products: tslib_1.__assign({}, state.products, (_e = {}, _e[action.storageKey] = action.products, _e)), fetchingProducts: tslib_1.__assign({}, state.fetchingProducts, (_f = {}, _f[action.storageKey] = false, _f)) });
        }
        case RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_VARIANTS_RESPONSE: {
            return tslib_1.__assign({}, state, { variants: tslib_1.__assign({}, state.variants, (_g = {}, _g[action.storageKey] = action.variants, _g)), fetchingVariants: tslib_1.__assign({}, state.fetchingGroups, (_h = {}, _h[action.storageKey] = false, _h)) });
        }
        case RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_GROUPS: {
            return tslib_1.__assign({}, state, { fetchingGroups: tslib_1.__assign({}, state.fetchingGroups, (_j = {}, _j[action.storageKey] = true, _j)) });
        }
        case RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_OFFERS: {
            return tslib_1.__assign({}, state, { fetchingOffers: tslib_1.__assign({}, state.fetchingOffers, (_k = {}, _k[action.storageKey] = true, _k)) });
        }
        case RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_PRODUCTS: {
            return tslib_1.__assign({}, state, { fetchingProducts: tslib_1.__assign({}, state.fetchingProducts, (_l = {}, _l[action.storageKey] = true, _l)) });
        }
        case RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_VARIANTS: {
            return tslib_1.__assign({}, state, { fetchingVariants: tslib_1.__assign({}, state.fetchingVariants, (_m = {}, _m[action.storageKey] = true, _m)) });
        }
        default: {
            return state;
        }
    }
};
export { reducer as railPackageServiceReducer };
